export default "__VITE_ASSET__BqLOF_WC__"